// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8b5da298","6":"c26b3d1a","20":"991ea448","43":"70f117ad","58":"34fd7c3b","198":"a26bb7c3","201":"0e61b817","388":"aabd21f2","401":"2de70ed7","604":"01163a8b","671":"1b29b83f","780":"3c1bf98d","812":"768feb12","824":"61117abc","828":"c8e4fc84","970":"529432af"}[chunkId] + ".chunk.js";
};